module.exports = __webpack_public_path__ + "img/suggestion-semipublic.2988d68a.svg";